











import { Component, Vue, Prop } from 'vue-property-decorator';
import UserForm from '@/components/forms/UserForm.vue';
import UserProfile from '@/classes/UserProfile';

@Component({
  components: {
    UserForm
  }
})
export default class UserEdit extends Vue {
  @Prop() public id!: string | number;

  get userName(): string {
    const user: UserProfile | undefined = this.$store.getters.getUserProfileById(this.id);
    return null === user || undefined === user ? '' : user.getFullName();
  }
}
